import logger from '@greenlight/logger';
import React, { Component } from 'react';

import Input from '../../../components/UI/CustomInputField';
import css from './Address.module.scss';

export const ADDRESS_FIELD_ID = 'PlacesPopupInputField';

export const formatSelectedAddress = details => {
  const address = details.name;
  let city = details.address_components.find(
    component => component.types.indexOf('locality') !== -1
  );
  if (!city)
    city = details.address_components.find(
      component => component.types.indexOf('administrative_area_level_3') !== -1
    );
  const state = details.address_components.find(
    component => component.types.indexOf('administrative_area_level_1') !== -1
  );
  const zip = details.address_components.find(
    component => component.types.indexOf('postal_code') !== -1
  );
  return {
    address,
    city: city ? city.short_name : '',
    state: state ? state.short_name : '',
    zip: zip ? zip.short_name : ''
  };
};

export default class PlacesPopup extends Component {
  state = {
    address: '',
    results: []
  };

  constructor(props) {
    super();
    this.state = {
      ...this.state,
      address: props.initialValue || this.state.address
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadAutoCompleteService();
  }

  loadAutoCompleteService = async (attempts = 0) => {
    if (typeof window.google !== 'undefined') {
      this.autocompleteService =
        new window.google.maps.places.AutocompleteService();
    } else if (attempts < 10) {
      const newAttempts = attempts + 1;
      await new Promise(resolve => setTimeout(resolve, 300));
      return this.loadAutoCompleteService(newAttempts);
    } else {
      logger.error(
        new Error('There was an issue loading the Google Places script')
      );
    }
  };

  onAddressChange = address => {
    this.setState({ address });
    this.props.updateAddress(address);

    if (address && this.autocompleteService) {
      this.autocompleteService.getPlacePredictions(
        { input: address },
        (predictions, status) => {
          if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
            this.setState({ results: [] });
            return;
          }
          this.setState({ results: predictions });
        }
      );
    }
  };

  selectAddress = index => {
    const placesService = new window.google.maps.places.PlacesService(
      document.createElement('div')
    );
    placesService.getDetails(
      { placeId: this.state.results[index].place_id },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          this.props.selectedAddress(place);
          this.setState({
            address: place.name
          });
        }
      }
    );
  };

  render() {
    return (
      <div
        className="fs-mask"
        onClose={() => this.props.close()}
        onClick={this.props.onClick}
      >
        <div>
          <div>
            <Input
              id={ADDRESS_FIELD_ID}
              placeholder="Your street address (PO Box not permitted)"
              autoComplete="off"
              autoCorrect="off"
              type="text"
              tidy
              value={this.state.address}
              onChange={this.onAddressChange}
              onFocus={this.props.onClick}
              error={this.props.error}
              data-testid="street-address"
            />
          </div>
          <div
            className={this.props.open ? css.addressResults : css.hideResults}
          >
            {this.state.results &&
            this.state.results.length &&
            this.props.open ? (
              <div>
                <ul
                  className={css.addressResultsList}
                  style={{
                    height: '100%',
                    marginTop: '-20px',
                    marginBottom: '0px'
                  }}
                  // FIXME: the next two props are invalid
                  selection
                  verticalAlign="middle"
                  data-testid="addressSuggestions"
                >
                  {(this.state.results || []).map((result, index) => (
                    <li
                      key={result.place_id}
                      data-testid={`addressSuggestion_${index}`}
                      style={{
                        fontSize: '16px',
                        cursor: 'pointer'
                      }}
                      onClick={() => this.selectAddress(index)}
                      className={
                        this.props.open ? css.addressResult : css.hideResults
                      }
                    >
                      <div
                        className={css.header}
                        style={{ fontWeight: 'bold', color: 'rgba(0,0,0,.87)' }}
                      >
                        {result.structured_formatting.main_text}
                      </div>
                      <div
                        className={css.content}
                        style={{ color: 'rgba(0,0,0,.8)' }}
                      >
                        {result.structured_formatting.secondary_text}
                      </div>
                    </li>
                  ))}
                </ul>
                <div id="google_attribution" className={css.googleAttribution}>
                  <img
                    style={{ padding: '5px', width: '150px' }}
                    src="/static/powered_by_google.png"
                    alt="Address suggestions powered by google"
                  />
                </div>
              </div>
            ) : (
              <div />
            )}
          </div>
        </div>
      </div>
    );
  }
}
